// import React, { useState } from "react";
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
// } from "recharts";
// import {
//   Card,
//   Box,
//   Typography,
//   Button,
//   Stack,
//   useTheme,
//   Divider,
//   ToggleButtonGroup,
//   ToggleButton,
// } from "@mui/material";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// export interface RevenueDataPoint {
//   month: string;
//   totalRevenue: number; // The solid purple line
//   paymentsReceived: number; // The dashed red/pink line
// }

// // Data adjusted to ensure 5M is the peak for the Y-Axis to display all ticks
// export const data: RevenueDataPoint[] = [
//   { month: "JAN", totalRevenue: 500000, paymentsReceived: 200000 },
//   { month: "FEB", totalRevenue: 1000000, paymentsReceived: 400000 },
//   { month: "MAR", totalRevenue: 2500000, paymentsReceived: 800000 },
//   { month: "APR", totalRevenue: 4000000, paymentsReceived: 1500000 },
//   { month: "MAY", totalRevenue: 5000000, paymentsReceived: 3000000 }, // Peak for 5M tick
//   { month: "JUN", totalRevenue: 3000000, paymentsReceived: 2500000 },
//   { month: "JUL", totalRevenue: 2000000, paymentsReceived: 1000000 },
//   { month: "AUG", totalRevenue: 1500000, paymentsReceived: 500000 },
//   { month: "SEP", totalRevenue: 2500000, paymentsReceived: 800000 },
//   { month: "OCT", totalRevenue: 3500000, paymentsReceived: 1200000 },
//   { month: "NOV", totalRevenue: 4500000, paymentsReceived: 2000000 },
//   { month: "DEC", totalRevenue: 1000000, paymentsReceived: 500000 },
// ];
// // --- Y-AXIS CONFIGURATION ---

// // Custom ticks array: 0, 50K, 100K, 500K, 1M, 5M
// const customTicks = [0, 50000, 100000, 500000, 1000000, 5000000];
// const maxYValue = 5000000;

// const formatYAxis = (tick: number): string => {
//   if (tick >= 1000000) {
//     // e.g., 5,000,000 -> 5M
//     return `${tick / 1000000}M`;
//   }
//   if (tick >= 1000) {
//     // e.g., 50,000 -> 50K
//     return `${tick / 1000}K`;
//   }
//   // Ensure 0 is returned as a string
//   return String(tick);
// };
// // ----------------------------

// const RevenueChart: React.FC = () => {
//   const theme = useTheme();
// const [timeRange, setTimeRange] = useState<'Daily' | 'Weekly' | 'Annually'>('Annually');

//   // Handler for the ToggleButtonGroup change
//   const handleRangeChange = (
//     event: React.MouseEvent<HTMLElement>,
//     newRange: 'Daily' | 'Weekly' | 'Annually' | null,
//   ) => {
//     if (newRange !== null) {
//       setTimeRange(newRange);
//       // NOTE: In a real app, you would fetch or filter data here 
//       // based on the newRange value (e.g., fetchDailyData(), etc.)
//       console.log(`Time range changed to: ${newRange}`);
//     }
//   };
//   // Define colors to match the chart image appearance
//   const totalRevenueColor =
//     theme.palette.mode === "light" ? "#962DFF" : "#B39DDB"; // Purple
//   const paymentsReceivedColor =
//     theme.palette.mode === "light" ? "#FF718B" : "#FFAB91"; // Red/Pink

//   return (
//     <>
//       {/* --- Header Section: Title and Buttons --- */}
//       <Stack
//         direction="row"
//         justifyContent="space-between"
//         alignItems="center"
//         mb={2}
//       >
//         <Typography variant="h6" sx={{ fontWeight: 400, color: "#9291A5" }}>
//           Statistics
//         </Typography>
//         <Stack direction="row" spacing={1}>
         
//           <ToggleButtonGroup
//             value={timeRange}
//             exclusive
//             onChange={handleRangeChange}
//             size="small"
//             sx={{
//               gap: "0.2rem",
//               backgroundColor: "#f5f5f5",
//               borderRadius: "16px",
//               padding: "10px",
//               "& .MuiToggleButton-root": {
//                 border: "none",
//                 borderRadius: "8px",
//                 textTransform: "none",
//                 fontWeight: 500,
//                 fontSize: "0.85rem",
//                 color: "#555",
//                 padding: "8px 17px",
//                 "&:hover": {
//                   backgroundColor: "#e0e0e0",
//                 },
//               },
//               "& .MuiToggleButton-root.Mui-selected": {
//                 backgroundColor: "#098963",
//                 color: "white",
//                 "&:hover": {
//                   backgroundColor: "#098963",
//                 },
//               },
//             }}
//           >
//             <ToggleButton value="Daily">Daily</ToggleButton>
//             <ToggleButton value="Weekly">Weekly</ToggleButton>
//             <ToggleButton value="Annually">Annually</ToggleButton>
//           </ToggleButtonGroup>
//         </Stack>
        
//       </Stack>

//       {/* --- Revenue Trend Title and Stats --- */}
//       <Stack direction="row" alignItems="center" spacing={1} mb={4}>
//         <Typography variant="h6" sx={{ fontWeight: 700, color: "#1E1B39" }}>
//           Revenue Trends
//         </Typography>
//       </Stack>
//       <Divider sx={{ mb: 2 }} />

//       {/* --- Chart Area --- */}
//       <Box sx={{ height: 400 }}>
//         <ResponsiveContainer width="100%" height="100%">
//           <LineChart
//             data={data}
//             // Increased 'bottom' margin to ensure the '0' tick label is visible
//             margin={{ top: 10, right: 30, left: 10, bottom: 70 }}
//           >
//             {/* Grid Lines: Horizontal only, dashed */}
//             <CartesianGrid
//               vertical={false}
//               strokeDasharray="3 3"
//               stroke="#e0e0e0"
//             />

//             {/* X-Axis: Months */}
//             <XAxis dataKey="month" axisLine={false} tickLine={false} />

//             {/* Y-Axis: Custom Ticks and Formatting (K/M) */}
//             <YAxis
//               ticks={customTicks}
//               tickFormatter={formatYAxis}
//               axisLine={false} // Hide the main axis line
//               tickLine={false} // Hide tick lines
//               domain={[0, maxYValue]} // Force domain to start at 0 and max at 5M
//               tick={{ fill: theme.palette.text.secondary, fontSize: 12 }}
//             />

//             <Tooltip
//               formatter={(value: number) => `$${value.toLocaleString()}`}
//             />

//             <Legend
//               verticalAlign="bottom"
//               align="left"
//               wrapperStyle={{ paddingTop: "20px" }}
//               iconType="circle"
//             />

//             {/* Line 1: Total Revenue (Solid, Purple) */}
//             <Line
//               type="monotone"
//               dataKey="totalRevenue"
//               name="Total Revenue"
//               stroke={totalRevenueColor}
//               strokeDasharray="8 8" // Creates the dashed line effect
//               dot={false}
//               strokeWidth={3}
//             />

//             {/* Line 2: Payments Received (Dashed, Red/Pink) */}
//             <Line
//               type="monotone"
//               dataKey="paymentsReceived"
//               name="Payments Received"
//               stroke={paymentsReceivedColor}
//               strokeDasharray="8 8" // Creates the dashed line effect
//               dot={false}
//               strokeWidth={3}
//             />
//           </LineChart>
//         </ResponsiveContainer>
//       </Box>
//     </>
//   );
// };

// export default RevenueChart;







// import React, { useState, useEffect } from "react";
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
// } from "recharts";
// import {
//   Card,
//   Box,
//   Typography,
//   Stack,
//   useTheme,
//   Divider,
//   ToggleButtonGroup,
//   ToggleButton,
// } from "@mui/material";
// import http from "../../../commonFunctions/httpClient";
// import { getLocalValue, LoacalVariables } from "../../../commonFunctions/CommonFunctions";

// interface RevenueDataPoint {
//   month: string;  // ✅ Keep "month" for XAxis dataKey="month"
//   totalRevenue: number;
//   paymentsReceived: number;
// }

// const RevenueChart: React.FC = () => {
//   const theme = useTheme();
//   const [data, setData] = useState<RevenueDataPoint[]>([]);
//   const [loading, setLoading] = useState(true);
//   const [labId, setLabId] = useState<string>("");
//   const [timeRange, setTimeRange] = useState<'Daily' | 'Weekly' | 'Annually'>('Annually');

//   // Y-Axis configuration (EXACT original)
//   const customTicks = [0, 50000, 100000, 500000, 1000000, 5000000];
//   const maxYValue = 5000000;

//   const formatYAxis = (tick: number): string => {
//     if (tick >= 1000000) return `${tick / 1000000}M`;
//     if (tick >= 1000) return `${tick / 1000}K`;
//     return String(tick);
//   };

//   // STEP 1: Get labId
//   useEffect(() => {
//     const userId = getLocalValue(LoacalVariables.UserId);
//     console.log("🔑 LAB ID:", userId);
//     setLabId(userId || "");
//   }, []);

//   // STEP 2: Fetch API data based on time range
//   const fetchRevenueData = async (range: 'Daily' | 'Weekly' | 'Annually') => {
//     if (!labId) return;

//     try {
//       setLoading(true);
//       const apiType = range === 'Daily' ? 'daily' : range === 'Weekly' ? 'weekly' : 'annual';
      
//       const response: any = await http.get(`lab/LabPayment/trends?labId=${labId}&type=${apiType}`);
//       console.log(`📈 ${range} API Response:`, response);
      
//       let apiData: { label: string; amount: number }[] = [];
//       if (response?.data && Array.isArray(response.data)) {
//         apiData = response.data;
//       } else if (Array.isArray(response)) {
//         apiData = response;
//       }

//       // ✅ Transform API data - use "month" field name (matches original XAxis)
//       const transformedData: RevenueDataPoint[] = apiData.map(item => ({
//         month: item.label,                           // ✅ "month" for XAxis dataKey="month"
//         totalRevenue: item.amount * 1.3,             // Total revenue (higher)
//         paymentsReceived: item.amount,               // Actual payments (API data)
//       }));

//       console.log("✅ CHART DATA:", transformedData);
//       setData(transformedData.length > 0 ? transformedData : []);
//     } catch (error) {
//       console.error(`💥 ${range} API Error:`, error);
//       setData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchRevenueData(timeRange);
//   }, [timeRange, labId]);

//   const handleRangeChange = (
//     event: React.MouseEvent<HTMLElement>,
//     newRange: 'Daily' | 'Weekly' | 'Annually' | null,
//   ) => {
//     if (newRange !== null) {
//       setTimeRange(newRange);
//     }
//   };

//   const totalRevenueColor = theme.palette.mode === "light" ? "#962DFF" : "#B39DDB";
//   const paymentsReceivedColor = theme.palette.mode === "light" ? "#FF718B" : "#FFAB91";

//   if (loading) {
//     return (
//       <Card sx={{ p: 3 }}>
//         <Box sx={{ height: 400, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//           <Typography>Loading revenue trends...</Typography>
//         </Box>
//       </Card>
//     );
//   }

//   return (
//     <Card sx={{ p: 3 }}>
//       {/* Header Section: Title and Toggle Buttons (100% ORIGINAL) */}
//       <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
//         <Typography variant="h6" sx={{ fontWeight: 400, color: "#9291A5" }}>
//           Statistics
//         </Typography>
//         <ToggleButtonGroup
//           value={timeRange}
//           exclusive
//           onChange={handleRangeChange}
//           size="small"
//           sx={{
//             gap: "0.2rem",
//             backgroundColor: "#f5f5f5",
//             borderRadius: "16px",
//             padding: "10px",
//             "& .MuiToggleButton-root": {
//               border: "none",
//               borderRadius: "8px",
//               textTransform: "none",
//               fontWeight: 500,
//               fontSize: "0.85rem",
//               color: "#555",
//               padding: "8px 17px",
//               "&:hover": { backgroundColor: "#e0e0e0" },
//             },
//             "& .MuiToggleButton-root.Mui-selected": {
//               backgroundColor: "#098963",
//               color: "white",
//               "&:hover": { backgroundColor: "#098963" },
//             },
//           }}
//         >
//           <ToggleButton value="Daily">Daily</ToggleButton>
//           <ToggleButton value="Weekly">Weekly</ToggleButton>
//           <ToggleButton value="Annually">Annually</ToggleButton>
//         </ToggleButtonGroup>
//       </Stack>

//       {/* Revenue Trend Title (100% ORIGINAL) */}
//       <Stack direction="row" alignItems="center" spacing={1} mb={4}>
//         <Typography variant="h6" sx={{ fontWeight: 700, color: "#1E1B39" }}>
//           Revenue Trends
//         </Typography>
//       </Stack>
//       <Divider sx={{ mb: 2 }} />

//       {/* Chart Area (100% ORIGINAL DESIGN + WAVES) */}
//       <Box sx={{ height: 400 }}>
//         <ResponsiveContainer width="100%" height="100%">
//           <LineChart
//             data={data}
//             margin={{ top: 10, right: 30, left: 10, bottom: 70 }}
//           >
//             {/* Grid Lines (100% ORIGINAL) */}
//             <CartesianGrid vertical={false} strokeDasharray="3 3" stroke="#e0e0e0" />

//             {/* X-Axis (100% ORIGINAL - shows API labels) */}
//             <XAxis dataKey="month" axisLine={false} tickLine={false} />

//             {/* Y-Axis (100% ORIGINAL K/M formatting) */}
//             <YAxis
//               ticks={customTicks}
//               tickFormatter={formatYAxis}
//               axisLine={false}
//               tickLine={false}
//               domain={[0, maxYValue]}
//               tick={{ fill: theme.palette.text.secondary, fontSize: 12 }}
//             />

//             {/* Tooltip (₹ formatting - Indian Rupees) */}
//             <Tooltip formatter={(value: number) => [`₹${value.toLocaleString()}`, null]} />

//             {/* Legend (100% ORIGINAL position) */}
//             <Legend verticalAlign="bottom" align="left" wrapperStyle={{ paddingTop: "20px" }} iconType="circle" />

//             {/* ✅ LINE 1: Total Revenue (WAVE + DASHED - EXACT original) */}
//             <Line
//               type="monotone"                    // ✅ WAVE effect
//               dataKey="totalRevenue"
//               name="Total Revenue"
//               stroke={totalRevenueColor}
//               strokeDasharray="8 8"              // ✅ Dashed
//               dot={false}
//               strokeWidth={3}
//             />

//             {/* ✅ LINE 2: Payments Received (WAVE + DASHED - EXACT original) */}
//             <Line
//               type="monotone"                    // ✅ WAVE effect
//               dataKey="paymentsReceived"
//               name="Payments Received"
//               stroke={paymentsReceivedColor}
//               strokeDasharray="8 8"              // ✅ Dashed
//               dot={false}
//               strokeWidth={3}
//             />
//           </LineChart>
//         </ResponsiveContainer>
//       </Box>
//     </Card>
//   );
// };

// export default RevenueChart;





import React, { useState, useEffect } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import {
  Card,
  Box,
  Typography,
  Stack,
  useTheme,
  Divider,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import http from "../../../commonFunctions/httpClient";
import { getLocalValue, LoacalVariables } from "../../../commonFunctions/CommonFunctions";

interface RevenueDataPoint {
  month: string;  // ✅ Keep "month" for XAxis dataKey="month"
  totalRevenue: number;
  paymentsReceived: number;
}

const RevenueChart: React.FC = () => {
  const theme = useTheme();
  const [data, setData] = useState<RevenueDataPoint[]>([]);
  const [loading, setLoading] = useState(true);
  const [labId, setLabId] = useState<string>("");
  const [timeRange, setTimeRange] = useState<'Daily' | 'Weekly' | 'Annually'>('Annually');

  // Y-Axis configuration (EXACT original)
  const customTicks = [0, 50000, 100000, 500000, 1000000, 5000000];
  const maxYValue = 5000000;

  const formatYAxis = (tick: number): string => {
    if (tick >= 1000000) return `${tick / 1000000}M`;
    if (tick >= 1000) return `${tick / 1000}K`;
    return String(tick);
  };

  // STEP 1: Get labId
  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId);
    console.log("🔑 LAB ID:", userId);
    setLabId(userId || "");
  }, []);

  // STEP 2: Fetch API data based on time range
  const fetchRevenueData = async (range: 'Daily' | 'Weekly' | 'Annually') => {
    if (!labId) return;

    try {
      setLoading(true);
      const apiType = range === 'Daily' ? 'daily' : range === 'Weekly' ? 'weekly' : 'annual';
      
      const response: any = await http.get(`lab/LabPayment/trends?labId=${labId}&type=${apiType}`);
      console.log(`📈 ${range} API Response:`, response);
      
      let apiData: { label: string; amount: number }[] = [];
      if (response?.data && Array.isArray(response.data)) {
        apiData = response.data;
      } else if (Array.isArray(response)) {
        apiData = response;
      }

      // ✅ Transform API data - use "month" field name (matches original XAxis)
      const transformedData: RevenueDataPoint[] = apiData.map(item => ({
        month: item.label,                           // ✅ "month" for XAxis dataKey="month"
        totalRevenue: item.amount * 1.3,             // Total revenue (higher)
        paymentsReceived: item.amount,               // Actual payments (API data)
      }));

      console.log("✅ CHART DATA:", transformedData);
      setData(transformedData.length > 0 ? transformedData : []);
    } catch (error) {
      console.error(`💥 ${range} API Error:`, error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRevenueData(timeRange);
  }, [timeRange, labId]);

  const handleRangeChange = (
    event: React.MouseEvent<HTMLElement>,
    newRange: 'Daily' | 'Weekly' | 'Annually' | null,
  ) => {
    if (newRange !== null) {
      setTimeRange(newRange);
    }
  };

  const totalRevenueColor = theme.palette.mode === "light" ? "#962DFF" : "#B39DDB";
  const paymentsReceivedColor = theme.palette.mode === "light" ? "#FF718B" : "#FFAB91";

  if (loading) {
    return (
      <Card sx={{ p: 3 }}>
        <Box sx={{ height: 400, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography>Loading revenue trends...</Typography>
        </Box>
      </Card>
    );
  }

  return (
    <Card sx={{ p: 3 }}>
      {/* Header Section: Title and Toggle Buttons (100% ORIGINAL) */}
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6" sx={{ fontWeight: 400, color: "#9291A5" }}>
          Statistics
        </Typography>
        <ToggleButtonGroup
          value={timeRange}
          exclusive
          onChange={handleRangeChange}
          size="small"
          sx={{
            gap: "0.2rem",
            backgroundColor: "#f5f5f5",
            borderRadius: "16px",
            padding: "10px",
            "& .MuiToggleButton-root": {
              border: "none",
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 500,
              fontSize: "0.85rem",
              color: "#555",
              padding: "8px 17px",
              "&:hover": { backgroundColor: "#e0e0e0" },
            },
            "& .MuiToggleButton-root.Mui-selected": {
              backgroundColor: "#098963",
              color: "white",
              "&:hover": { backgroundColor: "#098963" },
            },
          }}
        >
          <ToggleButton value="Daily">Daily</ToggleButton>
          <ToggleButton value="Weekly">Weekly</ToggleButton>
          <ToggleButton value="Annually">Annually</ToggleButton>
        </ToggleButtonGroup>
      </Stack>

      {/* Revenue Trend Title (100% ORIGINAL) */}
      <Stack direction="row" alignItems="center" spacing={1} mb={4}>
        <Typography variant="h6" sx={{ fontWeight: 700, color: "#1E1B39" }}>
          Revenue Trends
        </Typography>
      </Stack>
      <Divider sx={{ mb: 2 }} />

      {/* Chart Area (100% ORIGINAL DESIGN + WAVES) */}
      <Box sx={{ height: 400 }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            data={data}
            margin={{ top: 10, right: 30, left: 10, bottom: 70 }}
          >
            {/* Grid Lines (100% ORIGINAL) */}
            <CartesianGrid vertical={false} strokeDasharray="3 3" stroke="#e0e0e0" />

            {/* X-Axis (100% ORIGINAL - shows API labels) */}
            <XAxis dataKey="month" axisLine={false} tickLine={false} />

            {/* Y-Axis (100% ORIGINAL K/M formatting) */}
            <YAxis
              ticks={customTicks}
              tickFormatter={formatYAxis}
              axisLine={false}
              tickLine={false}
              domain={[0, maxYValue]}
              tick={{ fill: theme.palette.text.secondary, fontSize: 12 }}
            />

            {/* Tooltip (₹ formatting - Indian Rupees) */}
            <Tooltip formatter={(value: number) => [`₹${value.toLocaleString()}`, null]} />

            {/* Legend (100% ORIGINAL position) */}
            <Legend verticalAlign="bottom" align="left" wrapperStyle={{ paddingTop: "20px" }} iconType="circle" />

            {/* ✅ LINE 1: Total Revenue (WAVE + DASHED - EXACT original) */}
            <Line
              type="monotone"                    // ✅ WAVE effect
              dataKey="totalRevenue"
              name="Total Revenue"
              stroke={totalRevenueColor}
              strokeDasharray="8 8"              // ✅ Dashed
              dot={false}
              strokeWidth={3}
            />

            {/* ✅ LINE 2: Payments Received (WAVE + DASHED - EXACT original) */}
            <Line
              type="monotone"                    // ✅ WAVE effect
              dataKey="paymentsReceived"
              name="Payments Received"
              stroke={paymentsReceivedColor}
              strokeDasharray="8 8"              // ✅ Dashed
              dot={false}
              strokeWidth={3}
            />
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </Card>
  );
};

export default RevenueChart;
